import { useEffect, useState } from 'react'
import { getEvent } from '../../services/Event';
import { formatUSPhone } from '../../utils/phoneFormatter';
import { formatDateTimeForDisplay } from '../../utils/getUserDateFormat';
import Cookies from 'js-cookie';

const ViewMemberEvent = ({ id }: { id: string }) => {
    const token = Cookies.get("token-my-cdir");
    const [eventData, setEventData] = useState<any>({
        id: 0,
        eventName: "",
        groupId: 0,
        subGroupId: 0,
        startDate: "",
        endDate: "",
        sessions: "",
        eventCoordinatorNameEmailAddress: "",
        eventCoordinatorEmail: "",
        eventCoordinatorPhone: "",
        guest: "",
        description: "",
        isActive: true,
        location: "",
    });

    useEffect(() => {
        if (id) {
            getEvent(id, token!.toString())
                .then(res => {
                    setEventData(res);
                })
                .catch(error => console.log(error));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id])

    return (
        <div className="w-full relative">

            <div className="py-10 px-12 space-y-6">
                <div className='flex justify-end items-center'>
                    <button
                        onClick={() => window.dispatchEvent(new Event("closeEventModal"))}
                        className="text-gray-500 hover:text-black text-lg"
                    >
                        ✕
                    </button>
                </div>
                <div className="flex items-start justify-between">
                    <div className="flex items-center gap-3">
                        <h2 className="text-2xl font-bold text-secondary">
                            {eventData.eventName || "Event"}
                        </h2>

                        <span
                            className={`px-3 py-1 text-xs rounded-full font-medium ${eventData.isActive
                                ? "bg-green-100 text-green-600"
                                : "bg-red-100 text-red-600"
                                }`}
                        >
                            {eventData.isActive ? "Active" : "Inactive"}
                        </span>
                    </div>
                </div>

                <div>
                    <div className="flex gap-4 mt-2 text-sm text-gray-600">
                        <span><b>Sessions:</b> {eventData.sessions || "-"}</span>
                        <span><b>Guest:</b> {eventData.guest || "-"}</span>
                    </div>
                </div>

                <div className="border rounded-lg p-4">
                    <h3 className="text-md font-semibold text-gray-700 mb-3">
                        Date & Time
                    </h3>

                    <div className="grid xm:grid-cols-2 gap-4 text-sm">
                        <div>
                            <p className="text-gray-500">Start</p>
                            <p className="text-black font-medium">
                                {formatDateTimeForDisplay(eventData.startDate)}
                            </p>
                        </div>

                        <div>
                            <p className="text-gray-500">End</p>
                            <p className="text-black font-medium">
                                {formatDateTimeForDisplay(eventData.endDate)}
                            </p>
                        </div>
                    </div>
                </div>

                <div className="border rounded-lg p-4">
                    <h3 className="text-md font-semibold text-gray-700 mb-3">
                        Coordinator Details
                    </h3>

                    <div className="space-y-2 text-sm">
                        <p>
                            <span className="text-gray-500">Name:</span>{" "}
                            {eventData.eventCoordinatorNameEmailAddress || "-"}
                        </p>
                        <p className='break-all'>
                            <span className="text-gray-500">Email:</span>{" "}
                            {eventData.eventCoordinatorEmail || "-"}
                        </p>
                        <p>
                            <span className="text-gray-500">Phone:</span>{" "}
                            {formatUSPhone(eventData.eventCoordinatorPhone || "")}
                        </p>
                    </div>
                </div>

                <div className="border rounded-lg p-4">
                    <h3 className="text-md font-semibold text-gray-700 mb-3">
                        Additional Details
                    </h3>

                    <div className="space-y-2 text-sm">
                        <p>
                            <span className="text-gray-500">Location:</span>{" "}
                            {eventData.location || "-"}
                        </p>

                        <div>
                            <p className="text-gray-500">Description:</p>
                            <p className="text-black whitespace-pre-line">
                                {eventData.description || "-"}
                            </p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default ViewMemberEvent